import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { post_profssional_enquriy } from "../../api/ControllApi";
import { ASSET_BASE } from "../../utils/baseUrls";

export default function ProfessionalEnquiryDialouge({
  open,
  onClose,
  userid,
  serviceid,
  name,
  image,
  description,
}) {
  const [formData, setFormData] = useState({
    quote: "",
    date: "",
    time: "",
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      const now = new Date();
      setFormData((prev) => ({
        ...prev,
        date: now.toISOString().split("T")[0],
        time: now.toTimeString().slice(0, 5),
      }));
    }
  }, [open]);


  const handleChange = (field) => (e) => {
    setFormData((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  const handleQuery = async () => {
    if (!formData.quote.trim()) {
      toast.error("Please fill your requirement");
      return;
    }

    const payload = {
      service_id: serviceid,
      quote: formData.quote,
      date_preference: formData.date,
      time_preference: formData.time,
      user_id: userid,
    };

    setLoading(true);

    try {
      const res = await post_profssional_enquriy(payload);

      if (res?.status === true) {
        toast.success(res?.message || "Enquiry submitted successfully");

        setFormData({
          quote: "",
          date: new Date().toISOString().split("T")[0],
          time: new Date().toTimeString().slice(0, 5),
        });

        onClose(); 
      } else {
        toast.error(res?.message || "Something went wrong");
      }
    } catch (error) {
      const msg = error?.response?.data?.message || "Something went wrong";
      toast.error(msg);

    } finally {
      setLoading(false);
    }
  };

  const getImageUrl = (img) => {
    // If no image is provided, return placeholder
    if (!img) return "/assets/images/placeholder_img.png";

    // Handle array of images: pick first valid one
    if (Array.isArray(img)) {
      const firstValid = img.find((url) => url && typeof url === "string");
      if (firstValid) return getImageUrl(firstValid);
      return "/assets/images/placeholder_img.png";
    }

    // Handle comma-separated gallery string (common in backend response)
    if (typeof img === "string" && img.includes(",")) {
      return getImageUrl(img.split(",")[0]);
    }

    // If it's already a full URL, return it
    if (img.startsWith("http")) return img;

    // Remove leading slash if present to avoid double slashes
    let cleanPath = img.startsWith("/") ? img.substring(1) : img;

    // If path starts with 'storage/', it's relative to 'public/'
    if (cleanPath.startsWith("storage/")) {
      return `${ASSET_BASE}${cleanPath}`;
    }

    return `${ASSET_BASE}storage/${cleanPath}`;
  };

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="md"
      onClose={(e, reason) => {
        if (reason === "backdropClick") return;
        if (reason === "escapeKeyDown") return;
      }}
      PaperProps={{
        sx: { background: "transparent", boxShadow: "none" },
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          top: 14,
          right: 14,
          color: "#7E9F40",
          zIndex: 20,
        }}
      >
        <CloseIcon sx={{ fontSize: 28 }} />
      </IconButton>

      <DialogContent sx={{ p: { xs: 1, sm: 2 } }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: 3,
            bgcolor: "transparent", // Main container transparent
            borderRadius: 3,
            overflow: "hidden"
          }}
        >
          {/* LEFT IMAGE / INFO */}
          <Box
            sx={{
              flex: 1,
              p: 3,
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              bgcolor: "transparent", 
            }}
          >
            <Box
              sx={{
                bgcolor: "#fff",
                p: 3, 
                borderRadius: 4,
                boxShadow: "0px 2px 10px rgba(0,0,0,0.05)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                mb: 2,
                width: "100%",
                maxWidth: 320
              }}
            >
              <Box
                component="img"
                src={getImageUrl(image)}
                sx={{ width: "100%", height: 200, objectFit: "contain", mb: 2 }}
              />
              <Typography variant="h6" fontWeight={700} color="#333">
                {name}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                {/* {description} */}
              </Typography>
            </Box>
          </Box>

          {/* RIGHT FORM */}
          <Box sx={{ flex: 1.2, p: 3, bgcolor: "#fff", borderRadius: 3 }}>
            <Typography variant="h6" fontWeight={600} mb={3}>
              Enter Details
            </Typography>


            {/* DATE & TIME preference */}
            <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2, mb: 3 }}>
              <Box>
                <Typography variant="body2" fontWeight={500} mb={0.5}>Preferred Date</Typography>
                <TextField
                  type="date"
                  fullWidth
                  size="small"
                  value={formData.date}
                  onChange={handleChange("date")}
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
                />
              </Box>
              <Box>
                <Typography variant="body2" fontWeight={500} mb={0.5}>Preferred Time</Typography>
                <TextField
                  type="time"
                  fullWidth
                  size="small"
                  value={formData.time}
                  onChange={handleChange("time")}
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
                />
              </Box>
            </Box>

            {/* REQUIREMENT */}
            <Box mb={4}>
              <Typography variant="body2" fontWeight={500} mb={1}>
                Your Requirement:
              </Typography>
              <TextField
                multiline
                rows={3}
                fullWidth
                placeholder="Describe your requirement in detail..."
                value={formData.quote}
                onChange={handleChange("quote")}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                  }
                }}
              />
            </Box>

            {/* SUBMIT */}
            <Button
              variant="contained"
              fullWidth
              sx={{
                bgcolor: "#FEB821",
                color: "#fff",
                borderRadius: 2,
                py: 1.5,
                fontSize: 16,
                fontWeight: 600,
                textTransform: "none",
                "&:hover": { bgcolor: "#e5a71d" }
              }}
              onClick={handleQuery}
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} sx={{ color: "#fff" }} />
              ) : (
                "Send Enquiry"
              )}
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
